<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <span class="text-indigo-400 font-small">Datos </span>del Cliente
    </h1>
      <form @submit.prevent="store">
        
         <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl" style="margin: 15px;">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.ci" :error="form.errors.ci" class="pr-6 pb-8 w-full lg:w-1/3" label="ci" required/>
          <text-input v-model="form.nombres" :error="form.errors.nombres" class="pr-6 pb-8 w-full lg:w-1/3" label="Nombres" required/>
          <text-input v-model="form.apellidos" :error="form.errors.apellidos" class="pr-6 pb-8 w-full lg:w-1/3" label="Apellidos" required/>
          <select-input v-model="form.ocupacion_id" :error="form.errors.ocupacion_id" class="pr-6 pb-8 w-full lg:w-3/5" label="Ocupación" required>
            <option v-for="ocupacion in ocupaciones" :key="ocupacion.id" :value="ocupacion.id">{{ ocupacion.nombre}}</option>
        </select-input>
          <text-input v-model="form.telefono" :error="form.errors.telefono" class="pr-6 pb-8 w-full lg:w-1/5" label="Teléfono" required/>
          <text-input v-model="form.edad" :error="form.errors.edad" class="pr-6 pb-8 w-full lg:w-1/5" label="Edad" required/>
          <text-input v-model="form.ingresos_promedio" :error="form.errors.ingresos_promedio" class="pr-6 pb-8 w-full lg:w-1/4" label="Ingresos" required/>
          <select-input v-model="form.estado_civil" :error="form.errors.estado_civil" class="pr-6 pb-8 w-full lg:w-1/4" label="Estado Civil" required>
          <option>Casado</option>
          <option>Unión Libre</option>
           <option>Soltero</option>
           <option>Separado</option>
           <option>Viudo</option>
        </select-input>     
        <text-input v-model="form.cargas" :error="form.errors.cargas" class="pr-6 pb-8 w-full lg:w-1/4" label="Cargas Familiares" required/>
        <select-input v-model="form.tipo_vivienda" :error="form.errors.tipo_vivienda" class="pr-6 pb-8 w-full lg:w-1/4" label="Tipo Vivienda" required>
          <option>Propia</option>
          <option>Alquilada</option>
           <option>Familiar</option>
        </select-input>
        </div>
         </div>
         <h1 class="mb-8 font-bold text-3xl">
      <span class="text-indigo-400 font-small">Datos </span>de Visita
    </h1>
         <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl" style="margin: 15px;">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
       
        <select-input v-model="form.origen_cliente" :error="form.errors.origen_cliente" class="pr-6 pb-8 w-full lg:w-1/5" label="Origen Cliente" required>
          <option>Directo</option>
          <option>Referido</option>
          <option>Facebook</option>
          <option>TikTok</option>
          <option>Instagram</option>
          <option>Google</option>
          <option>Correo</option>
           <option>Call Center</option>
           <option>Whatsapeando</option>
        </select-input>
        <select-input v-model="form.closer_id" :error="form.errors.closer_id" class="pr-6 pb-8 w-full lg:w-1/5" label="Closer" required>
            <option v-for="closer in asesores" :key="closer.id" :value="closer.id">{{ closer.nombres}} {{closer.apellidos}}</option>
        </select-input>
        <select-input v-model="form.liner_id" :error="form.errors.liner_id" class="pr-6 pb-8 w-full lg:w-1/5" label="Liner" required>
            <option v-for="liner in asesores" :key="liner.id" :value="liner.id">{{ liner.nombres}} {{liner.apellidos}}</option>
        </select-input>
        <select-input v-model="form.proyecto_id" :error="form.errors.proyecto_id" class="pr-6 pb-8 w-full lg:w-2/5" label="Proyecto">
          <option disabled value="">Elije uno</option> 
          <option v-for="proyecto in proyectos" :key="proyecto.id" :value="proyecto.id">{{ proyecto.nombre}}</option>
        </select-input>
        <text-input v-model="form.manzana" :error="form.errors.manzana" class="pr-6 pb-8 w-full lg:w-1/5" label="Manzana" required/>
          <text-input v-model="form.lote" :error="form.errors.lote" class="pr-6 pb-8 w-full lg:w-1/5" label="Lote" required/>
          <text-input v-model="form.valor" :error="form.errors.valor" class="pr-6 pb-8 w-full lg:w-1/5" label="Valor" required/>
        <select-input v-model="form.venta" :error="form.errors.venta" class="pr-6 pb-8 w-full lg:w-1/5" label="Se Vendio" required>
          <option>Si</option>
          <option>No</option>
        </select-input>
        <text-input v-if="form.venta == 'Si'" v-model="form.entrada" :error="form.errors.entrada" class="pr-6 pb-8 w-full lg:w-1/5" label="Entrada" required/>
        <text-input  v-model="form.observacion" :error="form.errors.observacion" class="pr-6 pb-8 w-full lg:w-5/5" label="Observación" required/>

              </div></div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Guardar Datos</loading-button>
        </div>
      </form>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Cliente' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    organizations: Array,
    ocupaciones: Array,
    asesores: Array,
    proyectos: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        nombres: null,
        apellidos: null,
        organization_id: null,
        ocupacion_id: null,
        telefono: null,
        edad: null,
        ci: null,
        ingresos_promedio: null,
        estado_civil: null,
        tipo_vivienda: null,
        origen_cliente: null,
        closer_id: null,
        liner_id: null,
        proyecto_id: null,
        manzana: null,
        lote: null,
        venta: null,
        entrada: null,
        valor: null,
        observacion: null,
        estado: 1,
      }),
      imagenminiatura: '',
    }
  },
  methods: {
    store() {
      this.form.post(this.route('contacts.store'))
    },
   
  },
}
</script>
